<template>
  <div>
    <v-form @submit.prevent="acceptInvitation" ref="registerNewUserForm">
      <TextInput v-model="invitationAcceptData.name" label='登録名'/>
      <PasswordInput
        v-model="invitationAcceptData.password"
        :validationRules="passwordValidation(invitationAcceptData.password)"
        label='パスワード'
      />
      <PasswordInput
        v-model="invitationAcceptData.passwordConfirmation"
        :validationRules="confirmationPasswordValidation(invitationAcceptData.passwordConfirmation,invitationAcceptData.password)"
        label='パスワード（確認）'
      />
      <AcceptInvitationButton label="登録する" @acceptInvitation="acceptInvitation" />
    </v-form>
    <LoadingOverlay />
  </div>
</template>
<script>
import TextInput from '/src/components/uiParts/inputFields/TextInput'
import PasswordInput from '/src/components/uiParts/inputFields/PasswordInput'
import AcceptInvitationButton from '/src/components/pages/Invitation/AcceptInvitationButton'
import { mapState } from 'vuex'
import LoadingOverlay from '/app/components/commons/LoadingOverlay'
import axios from 'axios'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'AcceptInvitationContainer',
  components: {
    LoadingOverlay,
    TextInput,
    PasswordInput,
    AcceptInvitationButton
  },
  mixins: [formValidationUtils],
  computed: {
    ...mapState({
      authUser: (state) => state.UserAuthStore.currentUserAuth
    })
  },
  data () {
    return {
      invitationAcceptData: {
        name: '',
        password: '',
        passwordConfirmation: '',
        withCredentials: true
      }
    }
  },
  methods: {
    acceptInvitation () {
      if (!this.$refs.registerNewUserForm.validate()) return false

      this.$store.dispatch('LoaderStore/displayLoader')
      const invitationToken = this.$route.query.invitation_token
      this.invitationAcceptData.invitationToken = invitationToken
      axios
        .patch('/api/accept_invitation', { userAuth: this.invitationAcceptData })
        .then(() => {
          const payload = {
            status: 200,
            message: 'アカウントを新規作成しました。ログインしてください。'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.$router.push('/user_auths/sign_in')
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    }
  }
}
</script>
